module.exports = __webpack_public_path__ + "img/obch8.a348176c.svg";